import { TradingIntent } from "features/onboarding/guided/intent";
import {
  DcaThumb,
  GridThumb,
  HedgingThumb,
  SignalsThumb,
  TradingViewThumb,
} from "features/onboarding/art/MethodThumbs";

const METHOD_THUMBS = {
  signals: SignalsThumb,
  grid: GridThumb,
  tradingview: TradingViewThumb,
  dca: DcaThumb,
  hedging: HedgingThumb,
};

/** The compact illustration for a trading method. */
const MethodThumb = ({
  method,
  play = true,
}: {
  method: TradingIntent;
  play?: boolean;
}) => {
  const Thumb = METHOD_THUMBS[method];
  return <Thumb play={play} />;
};

export default MethodThumb;
